module.exports = __webpack_public_path__ + "static/img/active6.a980c5c8.png";